module.exports = __webpack_public_path__ + "img/img_map_car.e16d285b.png";